import _ from 'underscore';

export const AdGroup = {
  parent: 'Campaign',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'AdGroup',
    },
    Name: {
      'bulk-upload-header': 'Ad Group',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    StartDate: {
      'bulk-upload-header': 'Start Date',
    },
    TargetSetting: {
      'bulk-upload-header': 'Target Setting',
    },
    EndDate: {
      'bulk-upload-header': 'End Date',
    },
    AdScheduleUseSearcherTimeZone: {
      'bulk-upload-header': 'Ad Schedule Use Searcher Time Zone',
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
      bulkDeleteValueIfEmpty: true,
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
      bulkDeleteValueIfEmpty: true,
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
      bulkDeleteValueIfEmpty: true,
    },
    SearchBid: {
      'bulk-upload-header': 'Cpc Bid',
    },
    AdGroupPercentCpcBid: {
      'bulk-upload-header': 'Percent Cpc Bid',
    },
    AdGroupCommissionRate: {
      'bulk-upload-header': 'Commission Rate',
    },
    CpvBid: {
      'bulk-upload-header': 'Cpv Bid',
      type: 'number',
    },
    CpmBid: {
      'bulk-upload-header': 'Cpm Bid',
      type: 'number',
    },
    ContentBid: {
      'bulk-upload-header': 'Content Bid',
    },
    NativeBidAdjustment: {
      'bulk-upload-header': 'Bid Adjustment',
    },
    MultimediaAdBidAdjustment: {
      'bulk-upload-header': 'Multi Media Ad Bid Adjustment',
    },
    AdDistribution: {
      'bulk-upload-header': 'Network Distribution',
      'bulk-upload-mapper': function (value) {
        const mapping = {
          BingYahooAndSearchPartners: 'OwnedAndOperatedAndSyndicatedSearch',
          BingYahooOnly: 'OwnedAndOperatedOnly',
          SearchPartnersOnly: 'SyndicatedSearchOnly',
          InHousePromotion: 'InHousePromotion',
        };

        return _.result(mapping, value);
      },
    },
    Medium: {
      'bulk-upload-full-mapper': function (medium) {
        return [{
          key: 'Search Network',
          value: medium === 'Search' || medium === 'SearchAndContent' ? 'On' : 'Off',
        }, {
          key: 'Content Network',
          value: medium === 'Content' || medium === 'SearchAndContent' ? 'On' : 'Off',
        }];
      },
    },
    AdRotation: {
      'bulk-upload-header': 'Ad Rotation',
    },
    PricingModel: {
      'bulk-upload-header': 'Pricing Model',
    },
    RemarketingTargetingSetting: {
      'bulk-upload-full-mapper': function (bidType) {
        return [{
          key: 'Remarketing Targeting Setting',
          value: bidType,
        }];
      },
    },
    AdGroupType: {
      'bulk-upload-header': 'Ad Group Type',
    },
    HotelAdGroupType: {
      'bulk-upload-header': 'Hotel Ad Group Type',
      'bulk-upload-mapper': function (value) {
        return value.join('|');
      },
    },
    CashbackPercent: {
      'bulk-upload-header': 'Cashback Percent',
    },
    CashbackScope: {
      'bulk-upload-header': 'Cashback Scope',
    },
    CouponsEnabled: {
      'bulk-upload-header': 'Personalized Coupons Enabled',
    },
    Placement: {
      'bulk-upload-header': 'Placement',
    },
    Canvas: {
      'bulk-upload-header': 'Canvas',
    },
    UseOptimizedTargeting: {
      'bulk-upload-header': 'Use Optimized Targeting',
    },
    BoostPublisherIds: {
      'bulk-upload-header': 'Boost Publisher Ids',
    },
    BoostAccountIds: {
      'bulk-upload-header': 'Boost Account Ids',
    },
    BoostAdunitIds: {
      'bulk-upload-header': 'Boost Adunit Ids',
    },
    BoostTriggerIds: {
      'bulk-upload-header': 'Boost Trigger Ids',
    },
    FrequencyCapSettings: {
      'bulk-upload-header': 'Frequency Cap Settings',
      'bulk-upload-mapper': function (value) {
        if (_.isEmpty(value) || _.isEmpty(value[0]) || !value[0].CapValue) {
          return 'delete_value';
        }

        return JSON.stringify(value);
      },
    },
    BaseDomain: {
      'bulk-upload-header': 'Base Domain',
    },
  },
};
